// fix missing (closed) console bug in IE
if(!window.console) {console={}; console.log = function(){}; console.error = function(){}; console.warn = function(){};}
